import { useState, useEffect } from "react";
import { useAuth } from "../../../provider";
import { useFormik } from "formik";
import { API_URL } from "../../../constants";
import axios from 'axios';
import { Grid, Typography, Box, Checkbox, Paper, Alert, FormGroup } from '@mui/material';
import ButtonsMainGoTo from "../../../components/Button/ButtonMainGoTo";

import VitaminsAddOnCard from "../Subscribe/ShopCardsAddOn/VitaminsAddOnCard";
import OmegaAddOnCard from "../Subscribe/ShopCardsAddOn/OmegaAddOnCard";
import HormFemaleAddOnCard from "../Subscribe/ShopCardsAddOn/HormFemaleAddOnCard";
import HormMaleAddOnCard from "../Subscribe/ShopCardsAddOn/HormMaleAddOnCard";
import ThyroidAddOnCard from "../Subscribe/ShopCardsAddOn/ThyroidAddOnCard";
import EnergyAddOnCard from "../Subscribe/ShopCardsAddOn/EnergyAddOnCard";
import BonesAddOnCard from "../Subscribe/ShopCardsAddOn/BonesAddOnCard";
import FertilityAddOnCard from "../Subscribe/ShopCardsAddOn/FertilityAddOnCard";
import ColonAddOnCard from "../Subscribe/ShopCardsAddOn/ColonAddOnCard";

import * as Yup from 'yup';
import ButtonForm from "../../../components/Button/ButtonForm";
import * as c from '../../../constants';
import { stripePromise } from "../../../constants";

export default function AddPackages() {    

  const { state } = useAuth();

  const checkoutUrl = `${API_URL}/api/stripe/create-checkout-session-addon/`
  //const postSuccessUrl = `${API_URL}/api/stripe/post-success-addon/`;

  const [visits, setVisits] = useState([]);
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  //const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");

const visitId = visits?.[0]?.id || null;

// Fetch visits
  useEffect(() => {
    const fetchVisits = async () => {
      try {
        const res = await axios.get(`${c.API_URL}/api/current-lab-visit/`);
        const data = res.data;

      // Wrap in array for consistent mapping
      const visitsArray = data ? [data] : [];
      setVisits(visitsArray);
     
    } catch (err) {
      console.error("No existing lab visit found:", err);
    }
  };

  if (state?.user?.id) fetchVisits();
}, [state.user?.id]);


const addOns = [
  { id: "vitamins", name: "Vitamins & Micronutrients - Add On", price: 300, component: <VitaminsAddOnCard /> },
  { id: "omega", name: "OMEGA Health Lifestyle - Add On", price: 100, component: <OmegaAddOnCard /> },
  { id: "horm_female", name: "Hormone & Fertiliy Female -Add On", price: 200, component: <HormFemaleAddOnCard /> },
  { id: "horm_male", name: "Hormone & Cancer Prevention Male - Add On", price: 200, component: <HormMaleAddOnCard /> },
  { id: "thyroid", name: "Thyroid Health - Add On", price: 90, component: <ThyroidAddOnCard /> },
  { id: "atherosclerosis", name: "Atherosclerosis Prevention - Add On", price: 180, component: <EnergyAddOnCard /> },
  { id: "bones", name: "Bones Health", price: 140, component: <BonesAddOnCard /> },
  { id: "fertility", name: "Fertility & Ovarian Reserve - Add On", price: 50, component: <FertilityAddOnCard /> },
  { id: "ifob", name: "Colon Cancer Prevention IFOB Test - Add On", price: 20, component: <ColonAddOnCard /> },
];

const handleToggle = (id) => {
  setSelectedAddOns((prev) =>
    prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  );
};

const formik = useFormik({
    initialValues: {
    email: state.user?.email || "",
    userId: state.user?.id || "",
    stripe_cust_id: state.user?.stripe_customer_id || "",
  },

  validationSchema: Yup.object({
    email: Yup.string().email("Invalid email").required("Email required"),
    userId: Yup.number().required("User ID required"),
    stripe_cust_id: Yup.string().required("Stripe customer ID required"),
  }),

    onSubmit: async (values) => {
      if (selectedAddOns.length === 0) {
      setError("Please select at least one add-on package.");
      return;
    }
      try {
      setError(null);
      setMessage("Redirecting to Stripe checkout...");

      const payload = {
        email: values.email,
        userId: values.userId,
        custid: values.stripe_cust_id,
        labvisitId: visitId,
        items: selectedAddOns.map((id) => {
          const addOn = addOns.find((a) => a.id === id);
          return {
            sku: addOn.id,         // matches backend lookup via sku
            name: addOn.name,
            price: addOn.price,
            quantity: 1,
          };
        }),
      };

      const { data } = await axios.post(checkoutUrl, payload);

      // Redirect user to Stripe
      const stripe = await stripePromise;
      const result = await stripe.redirectToCheckout({ sessionId: data.sessionId });

      if (result.error) {
        console.error(result.error.message);
        setError("Stripe checkout failed to start.");
      }
    } catch (error) {
      console.error("Checkout error:", error.response?.data || error.message);
      setError("Checkout initialization failed.");
    }
  },
});


return (
<>        
 {/* ADD-ON PACKAGES */}  
  
    <Grid container spacing={2} sx={{px: {xs:0, sm:4, xl:12}, display: 'flex', justifyContent:'flex-end', alignItems: 'center',}}>
      {addOns.map((item) => (
        <Grid key={item.id} size={{xs: 12, lg: 6}}
        sx={{ display: 'flex', justifyContent:'center', alignItems: 'center', gap: 2, p:4, borderRadius:4,
            bgcolor: selectedAddOns.includes(item.id)
            ? 'tertiary.C200'
            : 'grey.C200',
          }}>
          <Checkbox
            checked={selectedAddOns.includes(item.id)}
            onChange={() => handleToggle(item.id)}
          />
 
          <Box>{item.component}</Box>
        
          </Grid>
        ))}  

      {/* ✅ Summary Bar */}
        <Grid size={12} sx={{ mt:2}}>
          <Paper elevation={3}
            sx={{p: 3,display: "flex",alignItems: "center",justifyContent: "space-between",borderRadius: 3,bgcolor: "grey.C100",}}>
            <Box>
              
              <Typography variant="subtitle1" fontWeight={600}>
                {selectedAddOns.length > 0
                  ? `${selectedAddOns.length} package${selectedAddOns.length > 1 ? "s" : ""} selected`
                  : "No Add-On Packages selected"}
              </Typography>
              
              <Typography variant="body2" color="text.secondary">
                Optionally choose one or more health packages before checkout.
              </Typography>
            
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Total: €{selectedAddOns
                .reduce((sum, id) => {
                  const addOn = addOns.find((a) => a.id === id);
                  return sum + (addOn?.price || 0);
                }, 0)
                .toFixed(2)}
            </Typography>

          </Paper>
        </Grid>

  {/* Cart + Stripe */}
  
      <Grid size={12} sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
        <form onSubmit={formik.handleSubmit}>
          <ButtonForm name="Proceed to Order" type="submit" disabled={selectedAddOns.length === 0 } />
        </form>
      </Grid>

 <Grid size={12} sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
      {error && <Grid size={12}><Alert severity="error">{error}</Alert></Grid>}
      {message && <Grid size={12}><Alert severity="info">{message}</Alert></Grid>}
    </Grid> 
      
        </Grid>
</>
)}


